import { useEffect, useState } from "react";
// import "./Component2.css";
import "../../sass/components/Filters/OfferedWorkingTypeFilter.scss";
const OfferedWorkingTypeFilter = ({
  activeOptions,
  setActiveOptions,
  newArray,
  setNewArray,
  show,
  setShow,
  title = "Working Type",
  isAdd,
}: {
  activeOptions: any;
  setActiveOptions: (newState: any) => void;
  newArray: string[];
  setNewArray: (newState: any) => void;
  show: boolean;
  setShow: (key: string) => void;
  title?: string;
  isAdd?: boolean;
}) => {
  // const [show, setShow] = useState<boolean>(false);

  const [options, setOptions] = useState<string[]>(["Remote", "Office"]);
  // const [activeOptions, setActiveOptions] = useState<boolean[]>(options.map(() => false));
  // const [newArray, setNewArray] = useState<string[]>([]);

  // Force options to always have both values
  useEffect(() => {
    setOptions(["Remote", "Office"]);
  }, []);

  // Initialize activeOptions if it's empty
  useEffect(() => {
    if (!activeOptions || activeOptions.length === 0) {
      setActiveOptions(options.map(() => false));
    }
  }, [activeOptions, options, setActiveOptions]);

  const handleClick2 = (optionIndex: number) => {
    const selectedOption = options[optionIndex];
    const updatedActiveOptions = [...activeOptions];
    updatedActiveOptions[optionIndex] = !updatedActiveOptions[optionIndex];

    if (!updatedActiveOptions[optionIndex]) {
      const updatedNewArray = newArray.filter(
        (option) => option !== selectedOption
      );
      setNewArray(updatedNewArray);
    } else {
      setNewArray([...newArray, selectedOption]);
    }

    setActiveOptions(updatedActiveOptions);
  };
  return (
    <>
      <div
        className="component set_border_2_grey"
        style={{ position: "relative" }}
      >
        <div onClick={() => setShow("offeredWorkingType")} className="title">
          <div className="" style={{ display: "flex" }}>
            <span style={{}}>{title}</span>
            <p className="ml_3" style={{ marginLeft: "4px" }}>
              {newArray.length > 0 && <span>({newArray.length})</span>}
            </p>
          </div>
          <i
            className={`${
              show && "rotate"
            } fa-solid fa-chevron-down cursor-pointer`}
          ></i>
        </div>

        {show && (
          <div
            className="show_component"
            style={
              isAdd
                ? { left: 0, right: 0, borderLeft: 0, borderRight: 0 }
                : undefined
            }
          >
            <div
              className="working-type-filter"
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                gap: "8px",
                padding: "8px 0",
                width: "fit-content",
                margin: "0 auto",
              }}
            >
              {options.map((option, index) => (
                <div
                  onClick={() => handleClick2(index)}
                  key={index}
                  className="option"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    cursor: "pointer",
                    padding: "4px 8px",
                    borderRadius: "6px",
                    transition: "all 0.2s ease",
                    border: "1px solid transparent",
                    backgroundColor: "transparent",
                  }}
                >
                  <div className="checkbox">
                    {" "}
                    <div
                      className={`option ${
                        activeOptions && activeOptions[index]
                          ? "picked"
                          : "inner_box"
                      }`}
                    ></div>
                  </div>
                  <p
                    className="p_option"
                    style={{
                      background:
                        activeOptions && activeOptions[index]
                          ? "rgba(94, 110, 120, 0.20)"
                          : "rgba(94, 110, 120, 0.10)",
                      padding: "5px 8px",
                      color: "#5E6E78",
                      borderRadius: "40px",
                      margin: 0,
                      fontSize: "11px",
                      whiteSpace: "nowrap",
                      fontWeight: 400,
                      transition: "all 0.2s ease",
                    }}
                  >
                    {option}
                  </p>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default OfferedWorkingTypeFilter;
